exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-tips[data-v-0bdc8c24]{padding-bottom:10px;font-size:14px;colo:#333}.title-tips span[data-v-0bdc8c24]{margin-right:14px;color:#999}", ""]);

// exports
